import { render } from "./ModalViewAttribute.vue?vue&type=template&id=1d6cfa20"
import script from "./ModalViewAttribute.vue?vue&type=script&lang=js"
export * from "./ModalViewAttribute.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__